module.exports = __webpack_public_path__ + "img/icon_management05.14187ae7.svg";